import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheRave} from "../TheRave";
import {TheRaveSound} from "../sound/TheRaveSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TimelineLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class TheRaveFSBetPresentation implements FlowStatePresentation {

    private _normalStartDelay: number = 0.06;
    private _fastStartDelay: number = 0.01;

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        const tl = new TimelineLite({onComplete: () => flowStateController.finish()});
        if (TheRave.model.currentParsedData.nextMode === GameMode.NORMAL) {
            TheRave.scatterController.reset();
            TheRave.stickySymbol.isNormal();
        } else if (!TheRave.model.isRestore) {
            TheRave.scatterController.removeScatterAnimations();
            TheRave.stickySymbol.verifyTotalMultiplier();
        }
        [0, 1, 2, 3, 4].forEach((i: number) => {
            TheRave.reels[i].reelView.hideNoWin();
        });
        TheRave.ways.reset();
        TheRave.nearwinPresentation.reset();
        TheRave.initialCountUp.remove();
        TheRave.waysWon.remove();
        TheRave.bigWinCountUp.remove();
        tl.add(() => TheRaveSound.playSoundEffect(TheRaveSound.REELS_SPINNING));

        TheRave.reels.forEach((reel, reelId) => {
            tl.add(reel.startSpin(true), (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId);
        });
        TheRave.enhancerReels.forEach((reel, reelId) => {
            tl.add(reel.startSpin(true), (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId);
        });

    }
}